var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTilexMedical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33333 8.33333V8.5C9.46118 8.93372 10.1174 10.112 9.89222 11.2992C9.66706 12.4864 8.62499 13.3427 7.41667 13.3333V13.3333H4.16667V13.3333V13.3333C2.97365 13.3037 1.96796 12.4349 1.7652 11.2589C1.56243 10.0828 2.21914 8.92748 3.33333 8.5V8.33333C3.33333 6.95355 4.45355 5.83333 5.83333 5.83333C7.21312 5.83333 8.33333 6.95355 8.33333 8.33333V8.33333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.83333 13.3333V18.3333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8333 15.8333V18.3333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 15.8333H16.9167C17.2501 15.8286 17.5486 15.6257 17.6755 15.3174C17.8025 15.0091 17.7334 14.6547 17.5 14.4167L15 11.6667H15.25C15.5834 11.662 15.8819 11.459 16.0089 11.1507C16.1358 10.8424 16.0668 10.4881 15.8333 10.25L13.3333 7.5H13.5C13.8487 7.53145 14.1798 7.34163 14.3289 7.02487C14.4779 6.7081 14.4131 6.33195 14.1667 6.08333L10.8333 2.5L9.66667 3.75",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilexMedical);
export default __webpack_public_path__ + "static/media/tilex-medical.e0d96ff94d86758234e420b4a319e68c.svg";
export { ForwardRef as ReactComponent };